<template>
  <SidebarComponent />

  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <div class="titolo-card__header">
            <div>
              <h1>Percorsi non iniziati</h1>
              <p class="titolo-card__subtitle">
                Elenco dei primi programmi con questionario iniziale o check iniziale ancora non completato.
              </p>
            </div>

            <div class="titolo-card__actions">
              <button
                v-if="canRunBackfill"
                type="button"
                class="btn ghost"
                :disabled="backfillRunning"
                @click="runBackfill"
              >
                {{ backfillRunning ? 'Aggiorno indice…' : (backfillCursorUserId ? 'Riprendi indice' : 'Aggiorna indice') }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="backfillStatus || backfillError" class="backfill-feedback">
          <span v-if="backfillStatus" class="muted">{{ backfillStatus }}</span>
          <span v-if="backfillError" class="error">{{ backfillError }}</span>
        </div>

        <section class="page-help">
          <div class="page-help__header">
            <span class="page-help__title">Cosa mostra la pagina</span>
            <span class="page-help__subtitle">Solo primi programmi non ancora avviati</span>
          </div>

          <div class="page-help__items">
            <div class="page-help__item">
              <strong>Mai iniziato</strong>
              <span>Il primo step iniziale del percorso e ancora aperto.</span>
            </div>
            <div class="page-help__item">
              <strong>Questionario iniziale</strong>
              <span>Il questionario del primo programma non e stato completato.</span>
            </div>
            <div class="page-help__item">
              <strong>Check iniziale</strong>
              <span>Il questionario iniziale e stato convertito in check, ma non e ancora stato compilato.</span>
            </div>
          </div>
        </section>

        <section class="summary-grid">
          <article class="summary-card">
            <span class="summary-card__label">Utenti</span>
            <strong class="summary-card__value">{{ uniqueUsersCount }}</strong>
            <span class="summary-card__hint">Utenti unici nella vista corrente</span>
          </article>

          <article class="summary-card">
            <span class="summary-card__label">Percorsi</span>
            <strong class="summary-card__value">{{ filteredRows.length }}</strong>
            <span class="summary-card__hint">Primi programmi non ancora iniziati</span>
          </article>
        </section>

        <section class="toolbar-card card-surface">
          <div class="filters-header">
            <button
              type="button"
              class="accordion-toggle"
              @click="filtersOpen = !filtersOpen"
              :aria-expanded="filtersOpen"
            >
              <div class="toggle-copy">
                <span class="toggle-title">Filtri e ricerca</span>
                <span class="toggle-subtitle">Studio, tipo iniziale, stato temporale e testo libero</span>
              </div>
              <span class="material-icons" aria-hidden="true">
                {{ filtersOpen ? 'expand_less' : 'expand_more' }}
              </span>
            </button>
          </div>

          <transition name="accordion">
            <div v-show="filtersOpen" class="accordion-panel">
              <div class="toolbar">
                <div class="toolbar-group toolbar-group--xl">
                  <label class="toolbar-label" for="pn-search">Ricerca</label>
                  <input
                    id="pn-search"
                    v-model.trim="searchText"
                    type="text"
                    class="input"
                    placeholder="Email, prodotto, programma, studio"
                  />
                </div>

                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="pn-type">Tipo iniziale</label>
                  <select id="pn-type" v-model="selectedInitialType" class="input">
                    <option value="">Tutti</option>
                    <option value="questionario">Questionario iniziale</option>
                    <option value="check_iniziale">Check iniziale</option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--lg">
                  <label class="toolbar-label" for="pn-studio">Studio</label>
                  <select id="pn-studio" v-model="selectedStudio" class="input">
                    <option value="">Tutti</option>
                    <option v-for="studio in studioOptions" :key="studio" :value="studio">
                      {{ studio }}
                    </option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="pn-status">Esito</label>
                  <select id="pn-status" v-model="selectedNonStartStatus" class="input">
                    <option value="">Tutti</option>
                    <option
                      v-for="option in nonStartStatusOptions.filter((option) => option.value)"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                </div>

                <div class="toolbar-actions">
                  <button class="btn ghost" type="button" @click="resetFilters">Reset</button>
                </div>

                <div class="toolbar-actions toolbar-actions--ghosts">
                  <button
                    type="button"
                    class="btn ghost"
                    :class="{ active: showImported }"
                    @click="showImported = !showImported"
                  >
                    {{ showImported ? 'Mostra anche importati' : 'Nascondi importati' }}
                  </button>

                  <button
                    type="button"
                    class="btn ghost"
                    :class="{ active: showHidden }"
                    @click="showHidden = !showHidden"
                  >
                    {{ showHidden ? 'Mostra nascosti' : 'Nascondi nascosti' }}
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </section>

        <div v-if="isLoading" class="loader"><h4>Caricamento…</h4></div>

        <template v-else>
          <div v-if="filteredRows.length" class="tickets">
            <table>
              <thead>
                <tr>
                  <th class="col-idx">#</th>
                  <th class="col-azioni">Azioni</th>
                  <th class="col-esito">Esito</th>
                  <th class="col-data">Inizio previsto</th>
                  <th class="col-email">Utente</th>
                  <th class="col-studio">Studio</th>
                  <th class="col-prodotto">Prodotto</th>
                  <th class="col-programma">Programma</th>
                  <th class="col-step">Step iniziale</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(row, index) in filteredRows"
                  :key="row.id"
                  :class="[
                    row.adminHidden ? 'row-hidden' : '',
                    row.isImported ? 'row-imported' : '',
                  ]"
                >
                  <td class="mono">{{ index + 1 }}</td>

                  <td>
                    <button
                      type="button"
                      class="profile-button"
                      :disabled="!row.uid"
                      title="Apri utente"
                      @click="gotoUser(row.uid)"
                    >
                      <span class="material-icons">visibility</span>
                    </button>

                    <button
                      type="button"
                      class="profile-button"
                      :disabled="!row.uid"
                      :title="row.stepKey === 'check_finale' ? 'Apri check iniziale' : 'Apri questionario iniziale'"
                      @click="openQuestionarioPage(row)"
                    >
                      <span class="material-icons">article</span>
                    </button>
                  </td>

                  <td>
                    <div class="meta-stack">
                      <select
                        class="input input--compact"
                        :value="row.nonStartStatus || ''"
                        :disabled="!row.percorsoId || row.stepIndex == null || row._savingNonStartStatus"
                        @change="updateNonStartStatus(row, $event.target.value)"
                      >
                        <option
                          v-for="option in nonStartStatusOptions"
                          :key="option.value || 'empty'"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                      <small v-if="row._savingNonStartStatus" class="muted">salvo…</small>
                    </div>
                  </td>

                  <td>
                    <div class="meta-stack">
                      <strong>{{ formatDate(row.plannedAt) || '—' }}</strong>
                      <small class="muted">Creato {{ formatDate(row.createdAt) || '—' }}</small>
                    </div>
                  </td>

                  <td>
                    <div class="meta-stack">
                      <strong>{{ row.userEmail || '—' }}</strong>
                      <small class="muted mono">{{ row.uid || '—' }}</small>
                    </div>
                  </td>

                  <td>{{ row.userStudio || '—' }}</td>

                  <td>
                    <div class="meta-stack">
                      <strong>{{ row.productName || '—' }}</strong>
                      <small v-if="row.sequenceTotal" class="muted">Percorso {{ row.sequenceIndex || 1 }}/{{ row.sequenceTotal }}</small>
                    </div>
                  </td>

                  <td>
                    <div class="meta-stack">
                      <strong>{{ row.programTitleNormalized || row.programTitle || '—' }}</strong>
                      <small v-if="row.stepName" class="muted">{{ row.stepName }}</small>
                    </div>
                  </td>

                  <td>
                    <div class="meta-stack">
                      <strong>{{ initialStepLabel(row) }}</strong>
                      <small class="muted">{{ row.stepKey || '—' }}</small>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="empty-state">
            <strong>Nessun percorso trovato.</strong>
            <span>Con i filtri correnti non risultano primi programmi ancora non iniziati.</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarComponent from '../SidebarComponent.vue';
import { getFirestore, collection, query, where, onSnapshot, doc, getDoc, updateDoc } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const BACKFILL_BATCH_SIZE = 25;
const BACKFILL_MAX_LOOPS = 250;
const NON_START_STATUS_OPTIONS = [
  { value: '', label: '—' },
  { value: 'non_iniziera', label: 'Non inizierà' },
  { value: 'in_lavorazione', label: 'In lavorazione' },
  { value: 'in_coda', label: 'In coda' },
  { value: 'annullato', label: 'Annullato' },
  { value: 'rimanda', label: 'Rimanda' },
];
const toDateSafe = (value) => {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
  if (typeof value?.toDate === 'function') {
    try {
      const converted = value.toDate();
      return converted instanceof Date && !Number.isNaN(converted.getTime()) ? converted : null;
    } catch {
      return null;
    }
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export default {
  name: 'PercorsiNonIniziati',
  components: { SidebarComponent },

  data() {
    return {
      savedRows: [],
      isLoading: true,
      filtersOpen: false,
      searchText: '',
      selectedInitialType: '',
      selectedStudio: '',
      selectedNonStartStatus: '',
      nonStartStatusOptions: NON_START_STATUS_OPTIONS,
      showImported: false,
      showHidden: false,
      indexUnsub: null,
      authUnsub: null,
      operatorUid: '',
      backfillRunning: false,
      backfillStatus: '',
      backfillError: '',
      backfillCursorUserId: '',
    };
  },

  computed: {
    canRunBackfill() {
      return !!this.operatorUid;
    },

    studioOptions() {
      const values = new Set();
      (this.savedRows || []).forEach((row) => {
        const studio = (row?.userStudio || '').trim();
        if (studio) values.add(studio);
      });
      return Array.from(values).sort((a, b) => a.localeCompare(b));
    },

    filteredRows() {
      const needle = (this.searchText || '').trim().toLowerCase();

      return (this.savedRows || [])
        .filter((row) => {
          if (!this.showImported && row.isImported) return false;
          if (!this.showHidden && row.adminHidden) return false;
          if (this.isExcludedPtProduct(row)) return false;
          if (this.selectedStudio && row.userStudio !== this.selectedStudio) return false;
          if (this.selectedInitialType && this.initialTypeKey(row) !== this.selectedInitialType) return false;
          if (this.selectedNonStartStatus && row.nonStartStatus !== this.selectedNonStartStatus) return false;
          if (!needle) return true;

          const haystack = [
            row.userEmail,
            row.uid,
            row.userStudio,
            row.productName,
            row.programTitle,
            row.programTitleNormalized,
            row.stepName,
            this.initialStepLabel(row),
          ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

          return haystack.includes(needle);
        })
        .slice()
        .sort((a, b) => {
          const aTime = toDateSafe(a.plannedAt)?.getTime() ?? Number.MAX_SAFE_INTEGER;
          const bTime = toDateSafe(b.plannedAt)?.getTime() ?? Number.MAX_SAFE_INTEGER;
          if (aTime !== bTime) return aTime - bTime;
          const aEmail = String(a.userEmail || '').toLowerCase();
          const bEmail = String(b.userEmail || '').toLowerCase();
          if (aEmail !== bEmail) return aEmail.localeCompare(bEmail);
          return String(a.productName || '').localeCompare(String(b.productName || ''));
        });
    },

    uniqueUsersCount() {
      const ids = new Set(this.filteredRows.map((row) => row.uid).filter(Boolean));
      return ids.size;
    },
  },

  mounted() {
    const auth = getAuth();
    this.operatorUid = auth.currentUser?.uid || '';
    this.authUnsub = onAuthStateChanged(auth, (user) => {
      this.operatorUid = user?.uid || '';
    });
    this.refreshIndexSubscription();
  },

  beforeUnmount() {
    if (typeof this.indexUnsub === 'function') this.indexUnsub();
    if (typeof this.authUnsub === 'function') this.authUnsub();
  },

  methods: {
    asDate(value) {
      return toDateSafe(value);
    },

    formatDate(value) {
      const date = this.asDate(value);
      if (!date) return '';
      return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },

    normalizeIndexRow(docSnap) {
      const data = docSnap.data() || {};
      const plannedAt = this.asDate(data.plannedAt || data.stepSnapshot?.plannedAt);
      const createdAt = this.asDate(data.createdAt || data.stepSnapshot?.questionnaire?.createdAt);
      const updatedAt = this.asDate(
        data.updatedAt ||
        data.stepSnapshot?.questionnaire?.updatedAt ||
        data.stepSnapshot?.adminUpdatedAt
      );
      const stepSnapshot = data.stepSnapshot && typeof data.stepSnapshot === 'object'
        ? { ...data.stepSnapshot }
        : {};

      if (plannedAt && !stepSnapshot.plannedAt) {
        stepSnapshot.plannedAt = plannedAt.toISOString();
      }

      return {
        ...data,
        id: docSnap.id,
        plannedAt: plannedAt ? plannedAt.toISOString() : null,
        createdAt: createdAt ? createdAt.toISOString() : null,
        updatedAt: updatedAt ? updatedAt.toISOString() : null,
        stepSnapshot,
        userEmail: data.userEmail || '',
        userStudio: data.userStudio || '',
        nonStartStatus: this.normalizeNonStartStatus(
          data.nonStartStatus || stepSnapshot.nonStartStatus || ''
        ),
        adminStatus: data.adminStatus || 'none',
        adminHidden: !!data.adminHidden,
        isImported: !!data.isImported,
        hasCompletedLater: !!data.hasCompletedLater,
        _savingNonStartStatus: false,
      };
    },

    normalizeStepsArray(steps) {
      if (Array.isArray(steps)) {
        return steps.map((step) => (step && typeof step === 'object' ? { ...step } : step));
      }

      if (steps && typeof steps === 'object') {
        return Object.keys(steps)
          .sort((a, b) => Number(a) - Number(b))
          .map((key) => {
            const step = steps[key];
            return step && typeof step === 'object' ? { ...step } : step;
          });
      }

      return [];
    },

    buildIndexQuery(db) {
      return query(
        collection(db, 'questionari_steps_index'),
        where('sequenceIndex', '==', 1)
      );
    },

    isConvertedInitialCheck(row) {
      return !!row?.stepSnapshot?.convertedFromQuestionario;
    },

    isNeverStartedRow(row) {
      if (!row) return false;
      if (!row.percorsoId) return false;
      if (row.hasCompletedLater) return false;

      const sequenceIndex = Number(row.sequenceIndex);
      if (Number.isFinite(sequenceIndex) && sequenceIndex !== 1) return false;

      const stepKey = String(row.stepKey || '').toLowerCase();
      if (stepKey === 'questionario') return true;
      if (stepKey === 'check_finale' && this.isConvertedInitialCheck(row)) return true;
      return false;
    },

    refreshIndexSubscription() {
      const db = getFirestore();

      if (typeof this.indexUnsub === 'function') {
        this.indexUnsub();
        this.indexUnsub = null;
      }

      this.isLoading = true;
      const indexQuery = this.buildIndexQuery(db);

      this.indexUnsub = onSnapshot(indexQuery, (snap) => {
        this.savedRows = snap.docs
          .map((docSnap) => this.normalizeIndexRow(docSnap))
          .filter((row) => this.isNeverStartedRow(row));
        this.isLoading = false;
      }, (error) => {
        console.error('listenRT questionari_steps_index non iniziati error:', error);
        this.savedRows = [];
        this.isLoading = false;
      });
    },

    initialTypeKey(row) {
      return this.isConvertedInitialCheck(row) ? 'check_iniziale' : 'questionario';
    },

    initialStepLabel(row) {
      return this.isConvertedInitialCheck(row) ? 'Check iniziale' : 'Questionario iniziale';
    },

    normalizeNonStartStatus(value) {
      const normalized = String(value || '').trim().toLowerCase();
      return NON_START_STATUS_OPTIONS.some((option) => option.value === normalized) ? normalized : '';
    },

    isExcludedPtProduct(row) {
      const productName = String(row?.productName || '').trim().toLowerCase();
      if (!productName) return false;

      return /^(10|20|50)\s*pt\b/.test(productName);
    },

    async updateNonStartStatus(row, nextValue) {
      if (!row?.percorsoId || row.stepIndex == null || row._savingNonStartStatus) return;

      const normalizedValue = this.normalizeNonStartStatus(nextValue);
      const previousValue = this.normalizeNonStartStatus(row.nonStartStatus);
      if (normalizedValue === previousValue) return;

      row._savingNonStartStatus = true;
      row.nonStartStatus = normalizedValue;

      try {
        const db = getFirestore();
        const ref = doc(db, 'percorsi', row.percorsoId);
        const snap = await getDoc(ref);
        if (!snap.exists()) throw new Error('Percorso non trovato.');

        const steps = this.normalizeStepsArray(snap.data()?.steps);
        const currentStep = steps[row.stepIndex];
        if (!currentStep || typeof currentStep !== 'object') {
          throw new Error('Step iniziale non trovato.');
        }

        const updatedAt = new Date().toISOString();
        steps[row.stepIndex] = {
          ...currentStep,
          nonStartStatus: normalizedValue || null,
          nonStartStatusUpdatedAt: normalizedValue ? updatedAt : null,
          adminUpdatedAt: updatedAt,
        };

        await updateDoc(ref, { steps });

        row.stepSnapshot = {
          ...(row.stepSnapshot || {}),
          ...steps[row.stepIndex],
        };
      } catch (error) {
        console.error('Errore salvataggio nonStartStatus:', error);
        row.nonStartStatus = previousValue;
        alert('Errore nel salvataggio dello stato.');
      } finally {
        row._savingNonStartStatus = false;
      }
    },

    resetFilters() {
      this.searchText = '';
      this.selectedInitialType = '';
      this.selectedStudio = '';
      this.selectedNonStartStatus = '';
      this.showImported = false;
      this.showHidden = false;
    },

    gotoUser(uid) {
      if (!uid || typeof window === 'undefined') return;
      const location = this.$router.resolve({
        name: 'UserProgrammi',
        params: { userId: uid },
      });

      if (!location?.href) return;
      window.open(location.href, '_blank', 'noopener');
    },

    resolveQuestionarioRouteName(row) {
      return this.isConvertedInitialCheck(row)
        ? 'UserProgrammiCheckFinale'
        : 'UserProgrammiQuestionario';
    },

    buildQuestionarioQuery(row) {
      const result = {};
      const assign = (key, value) => {
        if (value === undefined || value === null) return;
        const next = typeof value === 'string' ? value.trim() : String(value);
        if (!next) return;
        result[key] = next;
      };

      assign('percorsoId', row.percorsoId);
      assign('stepIndex', row.stepIndex);
      assign('stepKey', row.stepKey);
      assign('sequenceGroupId', row.sequenceGroupId);
      assign('sequenceIndex', row.sequenceIndex);
      assign('sequenceTotal', row.sequenceTotal);
      assign('productId', row.productId);
      assign('productName', row.productName);
      assign('programTitle', row.programTitle || row.programTitleNormalized);
      assign('plannedStartAt', row.plannedStartAt);
      assign('expireAt', row.expireAt);
      assign('stepName', row.stepName);
      assign('questionarioDocId', row.questionarioDocId || row.id);
      return result;
    },

    openQuestionarioPage(row) {
      if (!row?.uid || typeof window === 'undefined') return;

      const routeName = this.resolveQuestionarioRouteName(row);
      const queryParams = this.buildQuestionarioQuery(row);
      const location = this.$router.resolve({
        name: routeName,
        params: { userId: row.uid },
        query: queryParams,
      });

      if (!location?.href) return;
      window.open(location.href, '_blank', 'noopener');
    },

    async runBackfill() {
      if (this.backfillRunning) return;

      this.backfillRunning = true;
      this.backfillError = '';
      this.backfillStatus = this.backfillCursorUserId
        ? 'Ripresa aggiornamento indice questionari…'
        : 'Aggiornamento indice questionari in corso…';

      try {
        const functions = getFunctions(undefined, 'us-central1');
        const callable = httpsCallable(functions, 'backfillQuestionariStepsIndex', {
          timeout: 120000,
        });

        let nextUserId = this.backfillCursorUserId || '';
        let hasMoreUsers = true;
        let loop = 0;
        let totalUsers = 0;
        let totalPercorsi = 0;
        let totalWritten = 0;
        let totalDeleted = 0;

        while (hasMoreUsers) {
          loop += 1;
          if (loop > BACKFILL_MAX_LOOPS) {
            throw new Error('Limite di iterazioni superato. Riprova per continuare dal punto corrente.');
          }

          const payload = { batchSize: BACKFILL_BATCH_SIZE };
          if (nextUserId) payload.startAfterUserId = nextUserId;

          const res = await callable(payload);
          const data = res?.data || {};

          totalUsers += Number(data.processedUsers || 0);
          totalPercorsi += Number(data.processedPercorsi || 0);
          totalWritten += Number(data.written || 0);
          totalDeleted += Number(data.deleted || 0);

          hasMoreUsers = !!data.hasMoreUsers;
          nextUserId = data.nextUserId || '';
          this.backfillCursorUserId = hasMoreUsers ? nextUserId : '';
          this.backfillStatus = `Indice aggiornato: utenti ${totalUsers}, percorsi ${totalPercorsi}, scritti ${totalWritten}, rimossi ${totalDeleted}.`;

          if (!hasMoreUsers || !nextUserId) break;
        }
      } catch (error) {
        console.error('Errore backfillQuestionariStepsIndex:', error);
        this.backfillError = error?.message || 'Errore durante l’aggiornamento dell’indice.';
      } finally {
        this.backfillRunning = false;
      }
    },
  },
};
</script>

<style scoped>
.titolo-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.titolo-card__subtitle {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 0.95rem;
}

.titolo-card__actions {
  display: flex;
  gap: 10px;
}

.backfill-feedback {
  margin: 0 0 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.page-help {
  margin-bottom: 18px;
  padding: 18px 20px;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background:
    linear-gradient(135deg, rgba(248, 250, 252, 0.95), rgba(239, 246, 255, 0.9));
}

.page-help__header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 14px;
}

.page-help__title {
  font-weight: 700;
  color: #0f172a;
}

.page-help__subtitle {
  color: #64748b;
  font-size: 0.92rem;
}

.page-help__items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.page-help__item {
  display: grid;
  gap: 4px;
  padding: 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(191, 219, 254, 0.7);
}

.page-help__item strong {
  color: #1e3a8a;
}

.page-help__item span {
  color: #475569;
  font-size: 0.9rem;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}

.summary-card {
  display: grid;
  gap: 6px;
  padding: 18px;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  background: #fff;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.04);
}

.summary-card__label {
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}

.summary-card__value {
  font-size: 1.9rem;
  line-height: 1;
  color: #0f172a;
}

.summary-card__hint {
  font-size: 0.88rem;
  color: #64748b;
}

.toolbar-card {
  margin-bottom: 18px;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background: #fff;
}

.filters-header {
  padding: 6px;
}

.accordion-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 16px;
  border: 0;
  border-radius: 14px;
  background: #f8fafc;
  cursor: pointer;
}

.toggle-copy {
  display: grid;
  gap: 4px;
  text-align: left;
}

.toggle-title {
  font-weight: 700;
  color: #0f172a;
}

.toggle-subtitle {
  color: #64748b;
  font-size: 0.9rem;
}

.accordion-panel {
  padding: 4px 18px 18px;
}

.toolbar {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
  align-items: end;
}

.toolbar-group {
  display: grid;
  gap: 6px;
}

.toolbar-group--xl {
  grid-column: span 2;
}

.toolbar-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
}

.input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #fff;
  color: #0f172a;
}

.input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.input--compact {
  min-width: 160px;
}

.toolbar-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.toolbar-actions--ghosts {
  grid-column: 1 / -1;
}

.btn {
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 10px 14px;
  background: #fff;
  color: #0f172a;
  cursor: pointer;
}

.btn.primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.btn.ghost.active {
  background: #e0f2fe;
  border-color: #7dd3fc;
  color: #075985;
}

.btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.tickets {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background: #fff;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 12px 14px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
  vertical-align: top;
}

th {
  background: #f8fafc;
  color: #334155;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

tbody tr:last-child td {
  border-bottom: 0;
}

.row-hidden {
  opacity: 0.72;
}

.row-imported {
  background-image: linear-gradient(90deg, rgba(219, 234, 254, 0.35), transparent);
}

.profile-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-right: 8px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  color: #0f172a;
  cursor: pointer;
}

.profile-button:last-child {
  margin-right: 0;
}

.profile-button:disabled {
  opacity: 0.45;
  cursor: default;
}

.meta-stack {
  display: grid;
  gap: 6px;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, monospace;
}

.muted {
  color: #64748b;
}

.error {
  color: #b91c1c;
}

.loader,
.empty-state {
  padding: 28px 18px;
  border: 1px dashed #cbd5e1;
  border-radius: 18px;
  background: #fff;
  text-align: center;
}

.empty-state {
  display: grid;
  gap: 6px;
}

.accordion-enter-active,
.accordion-leave-active {
  transition: opacity 0.2s ease;
}

.accordion-enter-from,
.accordion-leave-to {
  opacity: 0;
}

@media (max-width: 900px) {
  .titolo-card__header {
    flex-direction: column;
  }

  .toolbar-group--xl {
    grid-column: auto;
  }
}
</style>
